// TODO: 10/7リリースの切り戻し用フラグ（#2599）。新運用が安定したら、フラグと旧UIのコードを削除する
// キーは current_session API の featureFlags（FeatureFlags.frontend_flags）と対応する。
export const FEATURE_FLAGS = {
  legacyUserNotices: "legacyUserNotices",
  hideHighRiskBarActions: "hideHighRiskBarActions",
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];
